"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.widgets.disabled': 'La función de widgets no está disponible en su plan actual.',
};
